import React from 'react';
import { SyncOutlined  } from '@ant-design/icons';

export default class Replacement extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            
        };
    }

    componentDidMount(){
    }

    	// from置空
	eliminate = (f) => {
		this.props.formRef.current.resetFields([f]);
	}


    render(){
        let { subscript } = this.props

        return(
            <div>
                <SyncOutlined style={{ marginLeft: "10px", display:"block" , lineHeight: "40px" , color:"rgb(191, 191, 191)" }} onClick={() => this.eliminate(subscript)}/>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// app/components/customPage/project-manager/Pages/Replacement.jsx